import React, { useState, useMemo } from 'react';
import { ConfirmationModal, REORDERABLE_LIST_HOVER_CLASS } from 'venn-components';
import { Icon, StudioButton } from 'venn-ui-kit';

interface ItemActionsProps {
  customDeleteText?: string;
  onDuplicate?: () => void;
  onDelete?: () => void;
}

type ConfirmationModalActionType = 'DELETE';

const ItemActions = ({ customDeleteText = 'item', onDuplicate, onDelete }: ItemActionsProps) => {
  const [confirmationModal, setConfirmationModal] = useState<ConfirmationModalActionType>();

  const [subhead, text, onProceed] = useMemo(() => {
    switch (confirmationModal) {
      case 'DELETE':
        return [
          `You are about to delete this ${customDeleteText}.`,
          `The configuration for this ${customDeleteText} will be lost permanently.`,
          () => {
            setConfirmationModal(undefined);
            onDelete?.();
          },
        ];
      default:
        return [undefined, undefined, undefined];
    }
  }, [confirmationModal, customDeleteText, onDelete]);

  return (
    <div className="studio-main-left-panel-item-actions text-venn-dark-blue gap-x-1 hidden group-hover/page:flex group-hover/item:flex">
      {onDuplicate && (
        <StudioButton
          size="tiny"
          onClick={(e) => {
            e.stopPropagation();
            onDuplicate?.();
          }}
          className={REORDERABLE_LIST_HOVER_CLASS}
        >
          <Icon type="clone" />
        </StudioButton>
      )}
      {onDelete && (
        <StudioButton
          size="tiny"
          aria-label="Delete"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmationModal('DELETE');
          }}
          className={REORDERABLE_LIST_HOVER_CLASS}
        >
          <Icon type="trash" />
        </StudioButton>
      )}
      {confirmationModal && text && onProceed && (
        <ConfirmationModal
          destructive
          text={text}
          subhead={subhead}
          onCancel={() => setConfirmationModal(undefined)}
          onProceed={onProceed}
        />
      )}
    </div>
  );
};

export default ItemActions;
